import {
    Component,
    ElementRef,
    Input
} from '@angular/core';

@Component({
    selector: 'pm-layout-9',
    templateUrl: './layout-9.html'  
})
export class Layout9Component {
   
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-9-component.ts